import React from 'react'
import SectionBase from './SectionBase'

export default () => (
  <SectionBase
    titleText="Separate your students from your personal contacts and connect more intimately wiht your students."
    gtmLearnObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'create-student',
      onboardingAction: 'click-learn-more',
    }}
    learnMoreLink="https://support.pga.com/en/articles/4852885-getting-started-with-students"
    gtmDoActionObject={{
      event: 'onboarding-click',
      onboardingCategory: 'onboarding-dashboard',
      onboardingLabel: 'create-student',
      onboardingAction: 'click-get-started',
    }}
    doActionLink="/pga-coach/students/list"
    doActionText="Create Student"
  />
)
